let navigationSource = 'route'
const scrollPositions = Object.create(null)
const scrollStorageKey = 'seller-page-scroll-positions'
let stopPendingScrollRestore = null
const pendingPageStates = Object.create(null)

// 菜单切换成功后再使缓存失效，避免路由加载期间重建仍在显示的旧页面。
export function navigateFromMenu(router, store, location, event) {
  if (event && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return
  if (event) event.preventDefault()

  const reset = () => {
    clearScrollPositions()
    sessionStorage.removeItem('myProduct_state')
    sessionStorage.removeItem('myDraft_state')
    store.commit('RESET_PAGE_CACHE')
    setPageScrollPosition({x: 0, y: 0})
  }
  if (router.resolve(location).route.fullPath === router.currentRoute.fullPath) {
    reset()
    return
  }

  const removeHook = router.afterEach(() => {
    removeHook()
    reset()
  })
  // 导航失败或被取消时移除监听，不能影响之后不相关的导航。
  return router.push(location).then(result => {
    removeHook()
    return result
  }, error => {
    removeHook()
    throw error
  })
}

function getListStateStorageKey() {
  return `seller-list-page-states-${localStorage.getItem('seller-userId') || 'current'}`
}

export function savePageState(route, state) {
  if (!route || !route.name) return
  const scrollTop = saveScrollPosition(route.name)
  try {
    const key = getListStateStorageKey()
    const saved = JSON.parse(localStorage.getItem(key) || '{}')
    saved[route.name] = {fullPath: route.fullPath, state, scrollTop}
    localStorage.setItem(key, JSON.stringify(saved))
  } catch (error) {
    // 存储不可用时不阻止打开详情。
  }
}

export function requestPageStateRestore(route) {
  if (!route || !route.name) return
  delete pendingPageStates[route.name]
  try {
    const saved = JSON.parse(localStorage.getItem(getListStateStorageKey()) || '{}')[route.name]
    if (!saved || saved.fullPath !== route.fullPath || !saved.state) return
    pendingPageStates[route.name] = saved.state
    if (typeof saved.scrollTop === 'number') scrollPositions[route.name] = saved.scrollTop
  } catch (error) {
    // 没有有效记录时使用页面原有的初始化方式。
  }
}

export function consumePageStateRestore(routeName) {
  const state = pendingPageStates[routeName] || null
  delete pendingPageStates[routeName]
  return state
}

export function clearPageStates() {
  Object.keys(pendingPageStates).forEach(key => delete pendingPageStates[key])
  try {
    localStorage.removeItem(getListStateStorageKey())
    sessionStorage.removeItem('orderType')
    sessionStorage.removeItem('reviewActiveName')
  } catch (error) {
    // 存储不可用时仍清除当前标签页待恢复的记录。
  }
}

function getPageScrollContainer() {
  if (typeof document === 'undefined') return null
  return document.querySelector('.main-scroll-container')
}

export function setNavigationSource(source) {
  navigationSource = source || 'route'
}

export function consumeNavigationSource() {
  const source = navigationSource
  navigationSource = 'route'
  return source
}

export function saveScrollPosition(routeName) {
  if (!routeName) return
  const scrollContainer = getPageScrollContainer()
  const scrollTop = scrollContainer
    ? scrollContainer.scrollTop
    : window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop || 0
  scrollPositions[routeName] = scrollTop
  try {
    const saved = JSON.parse(sessionStorage.getItem(scrollStorageKey) || '{}')
    saved[routeName] = scrollTop
    sessionStorage.setItem(scrollStorageKey, JSON.stringify(saved))
  } catch (error) {
    // 存储不可用时仍使用当前标签页内的位置记录。
  }
  return scrollTop
}

export function getScrollPosition(routeName) {
  if (!routeName) return null
  if (typeof scrollPositions[routeName] === 'number') return scrollPositions[routeName]
  try {
    const saved = JSON.parse(sessionStorage.getItem(scrollStorageKey) || '{}')
    return typeof saved[routeName] === 'number' ? saved[routeName] : null
  } catch (error) {
    return null
  }
}

export function setPageScrollPosition(position) {
  if (stopPendingScrollRestore) stopPendingScrollRestore()
  const x = position && typeof position.x === 'number' ? position.x : 0
  const y = position && typeof position.y === 'number' ? position.y : 0
  const scrollContainer = getPageScrollContainer()

  const applyPosition = () => {
    if (scrollContainer) {
      scrollContainer.scrollLeft = x
      scrollContainer.scrollTop = y
    } else if (typeof window !== 'undefined') {
      window.scrollTo(x, y)
    }
  }
  applyPosition()
  const scrollElement = scrollContainer || document.scrollingElement
  if (!scrollElement || y <= 0 || scrollElement.scrollTop >= y - 1) return

  // 新标签页返回时列表需要重新加载，等内容高度足够后再恢复。
  let observer = null
  let resizeObserver = null
  const stop = () => {
    if (observer) observer.disconnect()
    if (resizeObserver) resizeObserver.disconnect()
    clearTimeout(timeout)
    if (stopPendingScrollRestore === stop) stopPendingScrollRestore = null
  }
  const retry = () => {
    applyPosition()
    if (scrollElement.scrollTop >= y - 1) stop()
  }
  const timeout = setTimeout(stop, 10000)
  stopPendingScrollRestore = stop
  observer = new MutationObserver(retry)
  observer.observe(scrollContainer || document.body, {childList: true, subtree: true})
  if (typeof ResizeObserver !== 'undefined') {
    resizeObserver = new ResizeObserver(retry)
    resizeObserver.observe(scrollContainer ? scrollContainer.querySelector('.app-main') || scrollContainer : document.body)
  }
}

export function clearScrollPositions() {
  clearPageStates()
  if (stopPendingScrollRestore) stopPendingScrollRestore()
  try {
    sessionStorage.removeItem(scrollStorageKey)
  } catch (error) {
    // 保留内存记录的清理行为。
  }
  Object.keys(scrollPositions).forEach(key => {
    delete scrollPositions[key]
  })
}



// WEBPACK FOOTER //
// ./src/utils/pageNavigation.js